import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import { Link } from 'react-router-dom';

import SignupForm from './SignupForm';

class Signup extends Component {
	render() {
		if (!this.props.website.signups) {
			return null;
		}

		return (
			<div className='container'>
				<div className='row'>
					<div className='col-md-8 offset-md-2'>
						<SignupForm />
					</div>
				</div>
			</div>
		);
	}
}

export default ReduxConnect(Signup, {
	website: 'website',
});
